// src/components/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth"; // This import was missing!
import { getFirestore } from "firebase/firestore";
import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
    apiKey: "AIzaSyD5_wWUiolLT8XYTOholeb2WAKE-aCAnJ8",
    authDomain: "rsphysio-afa5b.firebaseapp.com",
    projectId: "rsphysio-afa5b",
    storageBucket: "rsphysio-afa5b",
    messagingSenderId: "935297529507",
    appId: "1:935297529507:web:15627e60af77f77c6ff116",
    measurementId: "G-VX7Z1X5SK7"
};

const requiredConfig = ['apiKey', 'authDomain', 'projectId'];
const missingConfig = requiredConfig.filter(key => !firebaseConfig[key]);

if (missingConfig.length > 0) {
  console.error('Missing Firebase configuration:', missingConfig);
  throw new Error(`Missing Firebase config: ${missingConfig.join(', ')}`);
}

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize services
export const db = getFirestore(app);
export const auth = getAuth(app); // Now this will work!

// Initialize Analytics (optional)
let analytics = null;
try {
  if (typeof window !== 'undefined') {
    analytics = getAnalytics(app);
  }
} catch (error) {
  console.log('Analytics not available:', error.message);
}

export { analytics };

// Development emulators (optional - for local testing)
if (process.env.REACT_APP_ENV === 'development' && typeof window !== 'undefined') {
  // Uncomment these lines if you want to use Firebase emulators locally
  // import { connectFirestoreEmulator, connectAuthEmulator } from 'firebase/firestore';
  // connectFirestoreEmulator(db, 'localhost', 8080);
  // connectAuthEmulator(auth, 'http://localhost:9099');
}

export default app;